import { render } from "./DevelopmentPage.vue?vue&type=template&id=7c83cd8e&scoped=true"
import script from "./DevelopmentPage.vue?vue&type=script&lang=ts"
export * from "./DevelopmentPage.vue?vue&type=script&lang=ts"

import "./DevelopmentPage.vue?vue&type=style&index=0&id=7c83cd8e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7c83cd8e"

export default script